module.exports = __webpack_public_path__ + "img/001-road.78e40c71.svg";